import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Standard shadcn/ui class-merging helper, shared across the whole UI package. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
